// The lead, end to end. One source of truth for the journey a pursuit travels.
export const LIFECYCLE = [
  { key: "intake", label: "Intake", blurb: "Invitation captured" },
  { key: "decision", label: "Bid decision", blurb: "Go / no-go" },
  { key: "estimating", label: "Estimating", blurb: "Takeoff & pricing" },
  { key: "proposal", label: "Proposal", blurb: "Package built" },
  { key: "submitted", label: "Submitted", blurb: "Sent to client" },
  { key: "outcome", label: "Outcome", blurb: "Won / lost / no-bid" },
];

const LEAD_STAGE = {
  new: "intake",
  review: "decision",
  qualified: "decision",
  no_bid: "outcome",
  lost: "outcome",
  converted: "estimating",
};
const BID_STAGE = {
  estimating: "estimating",
  proposal: "proposal",
  sent: "submitted",
  won: "outcome",
  lost: "outcome",
  declined: "outcome",
  cancelled: "outcome",
};

// Where an item currently sits in the lifecycle.
export const lifecycleStage = (item) =>
  (item.kind === "lead" ? LEAD_STAGE[item.status] : BID_STAGE[item.status]) || "intake";

export const lifecycleIndex = (stageKey) =>
  Math.max(0, LIFECYCLE.findIndex((s) => s.key === stageKey));

// Terminal states are "done" — the journey stops.
export const isTerminal = (item) =>
  ["no_bid", "lost"].includes(item.status) ||
  (item.kind === "bid" && ["won", "lost", "declined", "cancelled"].includes(item.status));

export const isWon = (item) => item.kind === "bid" && item.status === "won";

// The one action that moves this item forward — the "what happens next".
export function nextStep(item) {
  if (item.kind === "lead") {
    if (item.status === "new") return { key: "decide", label: "Run bid decision" };
    if (item.status === "review") return { key: "decide", label: "Finish the decision" };
    if (item.status === "qualified") return { key: "convert", label: "Convert to estimate" };
    return null;
  }
  const map = {
    estimating: { key: "open", label: "Build the estimate" },
    proposal: { key: "open", label: "Finish the proposal" },
    sent: { key: "open", label: "Awaiting decision" },
  };
  return map[item.status] || null;
}
